<div>
  <select #format (change)="changeFormat(format.value)"
    style="border-style: none; color: rgb(102, 102, 102); background: transparent; text-transform: uppercase;">
    <option value="1">PDF</option>
    <option value="2">PPTX</option>
  </select>
  <button class="btn-form-control" (click)=ReloadDashboard()>Export</button>
  <img src="../../../../assets/images/loading.gif" alt="loading" style="width: 20px;" *ngIf="descargado">
</div>

<div id="message-update" style="display: none;">
  <div class="success-msg message-text">
    <i class="fa fa-check"></i>
    Last update: {{lastUpdate}}
  </div>
</div>

<div class="grilla">
  <div id="plantefficiency" style=" width: 100%;" [ngStyle]="{ 'height': '88vh' }"></div>
</div>
